export default function linkToItem(displaySlug: string, itemId?: string) {
  return `/category/${displaySlug}${itemId ? `/${itemId}` : ''}`;
}
